import React, { FunctionComponent } from "react";
import {
    Typography,
    Stack,
    Grid,
    Chip,
    SvgIcon,
} from '@mui/material';
import { mdiCheck } from "@mdi/js"
import { Icon } from "@mdi/react";
import { IProps } from "./IProps";

const DEFAULT_SX = {
    border: "1px solid rgba(0, 0, 0, 0.6) ",
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.6)",
}

const CHECKED_SX = {
    backgroundColor: "#1BA0E9",
    color: "#FFFFFF",
}

export const CustomChip: FunctionComponent<IProps> = (props): JSX.Element => {
    const currentSx = props.checked ? CHECKED_SX : DEFAULT_SX;

    const checkMark: React.ReactElement | undefined = props.checked ? (
        <SvgIcon sx={{ fontSize: 18 }}>
            <Icon path={mdiCheck} color="#FFFFFF" />
        </SvgIcon>
    ) : undefined;

    return (

        <Chip
            icon={checkMark}
            variant="filled"
            label={props.label}
            sx={{ maxWidth: 200, width: 150, height: 35, fontSize: 14, cursor: "pointer", ...currentSx }}
            onClick={props.onClick}
        />
    )
}